<div *ngIf="campaignInfo && show.globalFormsSchema">

  <!-- Breadcrumb -->
  <app-campaign-3-breadcrumb  homeLink="" #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs" [campaignTypeName]="campaignTypeName" [campaignTypeDescription]="campaignTypeDescription" (onClickBreadcrumb)="breadcrumbClicked($event)"></app-campaign-3-breadcrumb>

  <br />

  <!-- Toolbar delle fasi -->
  <kv-phases-toolbar [phases]="campaignPhases" (onClickPhase)="phaseClicked($event)" *ngIf="show.phases"></kv-phases-toolbar>


  <div class="containerPrincipale" *ngIf="messageInstanceObject">

 
  <div class="infoBaseContainer" [ngClass]="{'formHidden': show.infoBase == false }">
      <app-campaign-3-info-base
      #infoBaseComponent
      [campaignInfo]="campaignInfo"
      [statusMapping]="statusMapping"
      [language]="language"
      [dateFormat]="dateFormat"
      [schemaMode]="schemaMode"
      [comboInizioFruizione]="combos.planning.modalitaInizioFruizione"
      [comboFineFruizione]="combos.planning.modalitaFineFruizione"
      [actionTypesList]="actionTypesList"
      [comboCouponType]="combos.infobase.couponTypes"
      [comboAdvantageType]="combos.infobase.advantageTypes"
      [messageInstanceObject]="messageInstanceObject"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      [ui_mode]="uiModes.infoBase"
      [coupon_mode]="coupon_mode"
      [readOnly]="readOnly"
      (formSchemaChanged)="onFormSchemaChanged($event)"
      (actionTypeChanged)="onActionTypeChanged($event)"
      (enableConfirmButton)="onConfirmButtonEnabled($event)">
    </app-campaign-3-info-base>
  </div>

    <!-- FASE 2 - Pianificazione -->
    <div class="pianificazioneContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.planning == false }">
      <!--
      <app-campaign-3-planning
      #planningComponent
      [language]="language"
      [dateFormat]="dateFormat"
      [statusMapping]="statusMapping"
      [comboGiornoSettimanaInizioFruizione]="comboGiornoSettimanaInizioFruizione"
      [comboGiornoSettimanaFineFruizione]="comboGiornoSettimanaFineFruizione"
      [comboInizioFruizione]="combos.planning.modalitaInizioFruizione"
      [comboFineFruizione]="combos.planning.modalitaFineFruizione"
      [messageInstanceObject]="messageInstanceObject"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      (rollingChange)="onRollingChanged($event)"
      [formSchema]="globalFormsSchema.properties.pianificazione"
      [campaignInfo]="campaignInfo"
      [ui_mode]="uiModes.planning"
      [readOnly]="readOnly"
      [coupon_mode]="coupon_mode"></app-campaign-3-planning>
      -->
      <app-campaign-3-planning
      #planningComponent
      [language]="language"
      [dateFormat]="dateFormat"
      [statusMapping]="statusMapping"
      [comboInizioFruizione]="combos.planning.modalitaInizioFruizione"
      [comboFineFruizione]="combos.planning.modalitaFineFruizione"
      [messageInstanceObject]="messageInstanceObject"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      [formSchema]="globalFormsSchema.properties.pianificazione"
      [campaignInfo]="campaignInfo"
      [ui_mode]="uiModes.planning"
      [readOnly]="readOnly"
      [coupon_mode]="coupon_mode"></app-campaign-3-planning>
    </div>

     <!-- FASE 3 - Tipi di azione -->
    <div class="actionTypeContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.actionType == false }">
      <app-campaign-3-action-type
      #actionTypeComponent
      [ui_mode]="uiModes.actionTypes"
      [coupon_mode]="coupon_mode"
      [miObjectTypesList]="miObjectTypesList"
      [miRuleTypesList]="miRuleTypesList"
      [couponType]="infoBaseComponent.fieldModel.coupon_type"
      [readOnly]="readOnly"
      [formSchema]="globalFormsSchema.properties.tipoAzioni"
      [messageInstanceObject]="messageInstanceObject"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
        (actionDynamicChanged)="onActionDynamicChanged($event)"

      ></app-campaign-3-action-type>
    </div>

     <!-- FASE 4 - Condizioni di emissione -->
    <div class="emissionConditionsContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.emissionConditions == false }">
      <app-campaign-3-emission-conditions
      #emissionConditionsComponent
      [language]="language"
      [campaignInfo]="campaignInfo"
      [formSchema]="globalFormsSchema.properties.emissione"
      [dateFormat]="dateFormat"
      [ui_mode]="uiModes.emissionConditions"
      [coupon_mode]="coupon_mode"
      [accumulatorList]="accumulatorListEmission"
      [miObjectTypesList]="miObjectTypesList"
      [miRuleTypesList]="miRuleTypesList"
      [messageInstanceObject]="messageInstanceObject"
      [readOnly]="readOnly"
      (anteprimaBarcodeChange)="anteprimaBarcodeChange($event)"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      [getProductOnlyBarcodeReady]="getProductOnlyBarcodeReady"
      [isActionDynamic]="isActionDynamic"
      ></app-campaign-3-emission-conditions>
    </div>

     <!-- FASE 5 - Condizioni di fruizione -->
     <div class="fruitionConditionsContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.fruitionConditions == false }">
      <app-campaign-3-fruition-conditions
      #fruitionConditionsComponent
      [language]="language"
      [dateFormat]="dateFormat"
      [ui_mode]="uiModes.fruitionConditions"
      [coupon_mode]="coupon_mode"
      [accumulatorList]="accumulatorListFruition"
      [miObjectTypesList]="miObjectTypesList"
      [miRuleTypesList]="miRuleTypesList"
      [messageInstanceObject]="messageInstanceObject"
      [statusMapping]="statusMapping"
      [formSchema]="globalFormsSchema.properties.fruizione"
      [readOnly]="readOnly"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      ></app-campaign-3-fruition-conditions>
    </div>

     <!-- FASE 6 - Customer Target -->
     <div class="customerTargetContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.customerTarget == false }">
      <app-campaign-3-customer-target
      #customerTargetComponent
      [language]="language"
      [dateFormat]="dateFormat"
      [ui_mode]="uiModes.customerTarget"
      [coupon_mode]="coupon_mode"
      [distributionListEmission]="distributionListEmission"
      [distributionListFruition]="distributionListFruition"
      [miObjectTypesList]="miObjectTypesList"
      [miRuleTypesList]="miRuleTypesList"
      [messageInstanceObject]="messageInstanceObject"
      [readOnly]="readOnly"
      [schemaMode]="schemaMode"
      [formSchema]="globalFormsSchema.properties.customerTarget"
      [dataInizioEmissione]="planningComponent ? planningComponent.fieldModel.data_inizio_emissione : null"
      [dataFineEmissione]="planningComponent ? planningComponent.fieldModel.data_fine_emissione : null"
      [dataInizioFruizione]="planningComponent ? planningComponent.fieldModel.data_inizio_fruizione : null"
      [dataFineFruizione]="planningComponent ? planningComponent.fieldModel.data_fine_fruizione : null"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      ></app-campaign-3-customer-target>
    </div>

     <!-- FASE 7 - Target Articoli -->
     <div class="productsTargetContainer" *ngIf="globalFormsSchema" [ngClass]="{'formHidden': show.productsTarget == false }">
      <app-campaign-3-products-target
      #productsTargetComponent
      [language]="language"
      [dateFormat]="dateFormat"
      [ui_mode]="uiModes.productsTarget"
      [coupon_mode]="coupon_mode"
      [listPaniereEmission]="paniereListEmission"
      [listPaniereFruition]="paniereListFruition"
      [listDepartmentEmission]="departmentListEmission"
      [listDepartmentFruition]="departmentListFruition"
      [listCategoriesEmission]="categoriesListEmission"
      [listCategoriesFruition]="categoriesListFruition"
      [listProductsEmission]="listProductsEmission"
      [listProductsFruition]="listProductsFruition"
      [miObjectTypesList]="miObjectTypesList"
      [miRuleTypesList]="miRuleTypesList"
      [formSchema]="globalFormsSchema.properties.targetArticoli"
      [readOnly]="readOnly"
      [messageInstanceObject]="messageInstanceObject"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      ></app-campaign-3-products-target>
    </div>


     <!-- FASE 8 - Touchpoint -->

     <div class="touchpointContainer" *ngIf="!gestioneNuovaTouchpoint && globalFormsSchema" [ngClass]="{'formHidden': show.touchpoint == false }">
      <app-campaign-3-touchpoint
      #touchpointComponent
      [language]="language"
      [actionTypeCode]="actionTypeCode"
      [actionTypesList]="actionTypesList"
      [dateFormat]="dateFormat"
      [touchpointListEmission]="touchpointListEmission"
      [touchpointListFruition]="touchpointListFruition"
      [ui_mode]="uiModes.touchpoint"
      [coupon_mode]="coupon_mode"
      [storeList]="storeList"
      [areeList]="areeList"
      [groupList]="groupList"
      [insegneList]="insegneList"
      [miObjectTypesList]="miObjectTypesList"
      [miRuleTypesList]="miRuleTypesList"
      [messageInstanceObject]="messageInstanceObject"
      [readOnly]="readOnly"
      [formSchema]="globalFormsSchema.properties.touchpoint"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
      ></app-campaign-3-touchpoint>
    </div>


     <div class="touchpointContainer" *ngIf="gestioneNuovaTouchpoint && globalFormsSchema" [ngClass]="{'formHidden': show.touchpoint == false }">
      <app-campaign-3-touchpoint
      #touchpointComponent
      [language]="language"
      [dateFormat]="dateFormat"
      [touchpointListEmission]="touchpointListEmission"
      [touchpointListFruition]="touchpointListFruition"
      [ui_mode]="uiModes.touchpoint"
      [coupon_mode]="coupon_mode"
      [storeList]="storeList"
      [areeList]="areeList"
      [groupList]="groupList"
      [insegneList]="insegneList"
      [miObjectTypesList]="miObjectTypesList"
      [miRuleTypesList]="miRuleTypesList"
      [messageInstanceObject]="messageInstanceObject"
      [readOnly]="readOnly"
      [formSchema]="globalFormsSchema.properties.touchpoint"
      (messageInstanceObjectChange)="messageInstanceObjectChange($event)"


      ></app-campaign-3-touchpoint>
    </div>




      <!-- FASE 9 - Validazioni -->
      <div class="validationsContainer" [ngClass]="{'formHidden': show.validations == false }">
        <app-campaign-3-validations
        #validationsComponent
        [language]="language"
        [dateFormat]="dateFormat"
        [statusList]="statusList"
        [campaignInfo]="campaignInfo"
        [actionTypeCode]="actionTypeCode"
        [statusMapping]="statusMapping"
        [touchpointListEmission]="touchpointListEmission"
        [touchpointListFruition]="touchpointListFruition"
        [distributionListEmission]="distributionListEmission"
        [distributionListFruition]="distributionListFruition"
        [accumulatorListEmission]="accumulatorListEmission"
        [accumulatorListFruition]="accumulatorListFruition"
        [ui_mode]="uiModes.validations"
        [coupon_mode]="coupon_mode"
        [readOnly]="readOnly"
        [messageInstanceObject]="messageInstanceObject"
        [deployTypeCoupon]="deployTypeCoupon"
        (editClicked)="onValidationEditClicked($event)"
        (messageInstanceObjectChange)="messageInstanceObjectChange($event)"
        (formSchemaChanged)="onFormSchemaChanged($event)"
        (saveWizard)="saveSelectedWizard()"
        [miRuleTypesList]="miRuleTypesList"
        [miObjectTypesList]="miObjectTypesList"
        (unpublishCompleted)="onReloadAfterUnpublish()"
        (resetState)="onReloadAfterReset()"
        ></app-campaign-3-validations>

      </div>

  </div>


  <div class="footerContainer">
    <br />
    <!-- Info campi obbligatori -->
    <div class="infoRequiredContainer">
      {{ 'campaign.fields_marked' | translate }} <span class="asterix">*</span> {{ 'campaign.fields_required' | translate }}
    </div>
    

    <!-- Bottoni Indietro e Conferma -->
    <div class="buttonsContainer">
      <button pButton *ngIf="currentPhaseIndex>0" (click)="onClickBackBtn()" icon="fa fa-chevron-left" iconPos="left" type="button" class="k-generic-btn footer-btn" label="{{'common.back' | translate}}"></button>
      <button pButton data-testid="confirmButton" type="submit" [disabled]="!enable.confirmButton || readOnly==true" *ngIf="currentPhaseIndex<campaignPhases.length && (currentPhaseIndex+1)!=statusMapping.validations.number" (click)="onClickConfirmBtn()" icon="fa fa-chevron-right" iconPos="right" class="k-generic-btn footer-btn" label="{{'common.confirm' | translate}}"></button>
      <button pButton *ngIf="currentPhaseIndex+1>=statusMapping.validations.number" (click)="onClickExitBtn()" icon="fa fa-chevron-right" iconPos="right" type="button" class="k-generic-btn footer-btn" label="{{'campaign.exitButton' | translate}}"></button>
      <button *ngIf="allowSaveActionTemplate" class="star-button">
        <i class="pi pi-star" [ngClass]="{'pi-star-favourite': favouriteAction}" (click)="onSaveFavourite()"></i>
    </button>

    </div>

    <div class="clear_fix"></div>

    <br />
  </div>
  <div *ngIf="showSuccessPopup" class="success-popup">
    {{ 'campaign.action_saved_success' | translate }}
  </div>
  <div *ngIf="showSuccessDeletePopup" class="success-popup">
    {{ 'campaign.action_deleted_success' | translate }}
  </div>
  



</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3.html